// Native import maps are install-once, so the map the app-proxy Worker renders
// into the shell and the one the client installs when there's no server map must
// agree — two Vue URLs would mean two reactivity systems in one page.

export type ComponentImportMap = {
  imports: Record<string, string>;
};

export const COMPONENT_IMPORT_MAP_ID = "mvt-import-map";
export const COMPONENT_IMPORT_MAP_ANCHOR_ID = "mvt-import-map-anchor";
export const VUE_IMPORT_URL = "https://esm.sh/vue@3.4.0";

// Only a plain object can be spread in; KV and global state are untrusted JSON,
// and a string would otherwise spread into char-indexed keys.
const spreadableImports = (imports: unknown): Record<string, string> =>
  typeof imports === "object" && !Array.isArray(imports)
    ? (imports as Record<string, string>) || {}
    : {};

// `@movement/` is dropped rather than pointing at a bad origin when the artifact
// base is absent, so a config gap costs one namespace instead of the whole map.
export const buildComponentImportMap = (
  artifactBaseUrl?: string | null,
  componentImports?: unknown
): ComponentImportMap => {
  const base = (artifactBaseUrl || "").trim().replace(/\/+$/, "");

  return {
    imports: {
      vue: VUE_IMPORT_URL,
      ...(base ? { "@movement/": `${base}/movement/` } : {}),
      ...spreadableImports(componentImports)
    }
  };
};
